/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
	$('img').bind('contextmenu', function(e) {
	    return false;
	});

	// Infinite scroll in collection
	
	if($('.template-collection').length > 0){
		$.fn.isInViewport = function () {
		    let elementTop = $(this).offset().top;
		    let elementBottom = elementTop + $(this).outerHeight();

		    let viewportTop = $(window).scrollTop();
		    let viewportBottom = viewportTop + $(window).height();

		    return elementBottom > viewportTop && elementTop < viewportBottom;
		};

		var currentColl = window.location.href;
		var counter = 2

		var scrollInterval = setInterval(function(){

			if ($('.scroll-check').isInViewport()) {
				$('.scroll-check').remove();

				var page = currentColl + '?page=' + counter;
		        $.ajax({
				    url: page,
				    dataType: 'html',
				    success: function(html) {
				        var div = $('.CollectionMain .ProductList', $(html)).children();
				        $('.CollectionMain .ProductList').append(div);
				        $('.CollectionMain .ProductList .ProductItem').css('visibility', 'visible');
				        if(div.length <= 1) {
				        	clearInterval(scrollInterval);
				        	$('.scroll-check').remove();
				        }
				    }
				});
				$('.CollectionMain .ProductListWrapper').append("<span class='scroll-check'></span>");
				counter += 1;
		    } 
		}, 700);
	}

	// Infinite scroll in search
	
	if($('.template-search').length > 0){
		$.fn.isInViewport = function () {
		    let elementTop = $(this).offset().top;
		    let elementBottom = elementTop + $(this).outerHeight();

		    let viewportTop = $(window).scrollTop();
		    let viewportBottom = viewportTop + $(window).height();

		    return elementBottom > viewportTop && elementTop < viewportBottom;
		};

		var currentSearch = window.location.href;
		var searchSplit = currentSearch.split('?');
		var searchUrl = searchSplit[0]; 
		var searchQuery = searchSplit[1];
		var counter = 2

		var scrollInterval = setInterval(function(){

			if ($('.scroll-check').isInViewport()) {
				$('.scroll-check').remove();

				var page = searchUrl + '?page=' + counter + '&' + searchQuery;
		        $.ajax({
				    url: page,
				    dataType: 'html',
				    success: function(html) {
				        var div = $('.ProductList', $(html)).children();
				        console.log(div.length)
				        $('.ProductList').append(div);
				        $('.ProductList .ProductItem').css('visibility', 'visible');
				        if(div.length <= 1) {
				        	clearInterval(scrollInterval);
				        	$('.scroll-check').remove();
				        }
				    }
				});
				$('.ProductList').append("<span class='scroll-check'></span>");
				counter += 1;
		    } 
		}, 700);
	}

	// Infinite scroll in blog

	if($('.template-blog').length > 0){
		$.fn.isInViewport = function () {
		    let elementTop = $(this).offset().top;
		    let elementBottom = elementTop + $(this).outerHeight();

		    let viewportTop = $(window).scrollTop();
		    let viewportBottom = viewportTop + $(window).height();

		    return elementBottom > viewportTop && elementTop < viewportBottom;
		};

		var currentColl = window.location.href;
		var counter = 2

		var scrollInterval = setInterval(function(){

			if ($('.scroll-check').isInViewport()) {
				$('.scroll-check').remove();

				var page = currentColl + '?page=' + counter;
		        $.ajax({
				    url: page,
				    dataType: 'html',
				    success: function(html) {
				        var div = $('.ArticleList', $(html)).children();
				        $('.ArticleList').append(div);
				        $('.ArticleList .ArticleItem').css('visibility', 'visible');
				        if(div.length <= 1) {
				        	clearInterval(scrollInterval);
				        	$('.scroll-check').remove();
				        }
				    }
				});
				$('.ArticleListWrapper').append("<span class='scroll-check'></span>");
				counter += 1;
		    } 
		}, 700);
	}

	// Footer menu on mobile

	$('.Footer__Title').on('click', function(){
		$(this).parent().toggleClass('active');
	});

	// Cookie consent banner

	(function() {
		if (!localStorage.getItem('cookieconsent')) {
			document.querySelector('.cookie-consent-banner').style.display = 'block';
			document.querySelector('.cookie-consent-banner .Button').onclick = function(e) {
				e.preventDefault();
				document.querySelector('.cookie-consent-banner').style.display = 'none';
				localStorage.setItem('cookieconsent', true);
			};
		}
	})();

	// Update checkout URL

	$(document).on('click','.cart-checkout', function(e){
		e.preventDefault();
		var currentUrl = window.location.href;

		if (currentUrl.indexOf('.com/gl') > -1) {
			$('.cart-checkout').attr('href', '/checkout?locale=gl');
		} else if (currentUrl.indexOf('.com/en') > -1) {
			$('.cart-checkout').attr('href', '/checkout?locale=en');
		} 

		$(this).trigger('click');
	});

	$('p').each(function() {
	 var $this = $(this);
	 if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
	     $this.remove(); 
	}); 

	$('.menu-help').on('click touch', function(e){
		e.preventDefault();
		$('#sidebar-menu .Drawer__Close').trigger('click');
	    $("#section-footer .Footer__Block:nth-of-type(2) .Footer__Title").trigger('click');
		$('html, body').animate({
	        scrollTop: $("#section-footer").offset().top - 100
	    }, 2000);
	});

	// Disable click on unavailable variants

	// $('.disabled-variant').on('click touch', function(e){
	// 	e.preventDefault();
	// 	e.StopPropagation();
	// });
		
});

